<template>
  <div class="content">
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <span v-if="dominItem.templateId === 'temp3'" style="font-size: 20px; color: #333333">{{ dominItem.logoName || 'Logo' }}</span>
      <div>
        <span>{{ nowDate }}</span>
        <span @click="changeType(1)" style="margin: 0 20px">{{ $t('con_home') }}</span>
        <span @click="changeType(1)">{{ $t('con_about') }}</span>
      </div>
    </div>
    <div class="logo" v-if="dominItem.templateId === 'temp1' || dominItem.templateId === 'temp3'">
      <span class="logo-name" v-if="dominItem.templateId !== 'temp3'">{{ dominItem.logoName || 'Logo' }}</span>
      <div class="category" :class="[dominItem.templateId === 'temp3' ? 'catetemp3' : '']">
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
      </div>
    </div>

    <div class="logo" style="justify-content: space-between" v-if="dominItem.templateId === 'temp2'">
      <div class="category categtemp2">
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
      </div>
      <span class="logo-name" style="text-align: right">{{ dominItem.logoName || 'Logo' }}</span>
    </div>

    <div style="padding: 0 10%">
      <div class="content-hot" v-if="bestInfo">
        <div class="hot"><span class="hot-name">{{ $t('con_bestnew') }}</span></div>
        <div class="img-Box">
          <div style="text-align: center;">
          <img @click="toDetail(bestInfo.articleShortName)" :src="bestInfo.articleImage || defaultImg" alt="">

          </div><div class="title-box" @click="toDetail(bestInfo.articleShortName)">
            <h2 class="title" @click="toDetail(bestInfo.articleShortName)">
              {{ bestInfo.articleTitle }}
            </h2>
            <div class="post-meta">
<!--              <span class="country">{{ $t('con_time') }}</span>-->
<!--              <span>{{ bestInfo.uploadTime }}</span>-->
              <span style="margin: 0 20px; color: #ffffff" class="see-number">{{ $t('con_see') }}</span>
              <span class="number">{{ bestInfo.articleReadNum }}</span>
            </div>
          </div>
        </div>


        <div class="post-list">
          <div v-for="(item, index) in articleList" class="post-list-box">
            <template v-if="index < 4">
              <div class="bot-img">
                <img @click="toDetail(item.articleShortName)" :src="item.articleImage || defaultImg" alt="">
              </div>
              <div style="padding: 10px 20px 20px">
                <span class="title" @click="toDetail(item.articleShortName)">{{ item.articleTitle }}</span>
                <div class="time">
<!--                  <span class="country">{{ $t('con_time') }}</span>-->
<!--                  <span>{{ item.uploadTime }}</span>-->
                  <span style="margin: 0 20px" class="see-number">{{ $t('con_see') }}</span>
                  <span class="number">{{ item.articleReadNum }}</span>

                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>


    <div class="last-news">
      <!--          -->
      <div class="hot"><span class="hot-name">{{ $t('con_bestnew') }}</span></div>

      <div class="last-news-content">
        <div v-for="item in latestNewsList"
             style="display: flex; justify-content: space-between;background: #ffffff;margin-bottom: 30px">
          <div class="imgbox">
            <img :src="item.articleImage || defaultImg" alt="">
          </div>
          <div class="last-news-content-box">
            <span  class="articleIntro" style="margin-top: 10px">{{ item.articleTitle }}</span>
            <div class="time">
<!--              <span class="country">{{ $t('con_time') }}</span>-->
<!--              <span>{{ item.uploadTime }}</span>-->
              <span style="margin: 0 20px" class="see-number">{{ $t('con_see') }}</span>
              <span class="number">{{ item.articleReadNum }}</span>
            </div>
            <span class="articleIntro" style="margin: 10px 0; font-size: 16px;color: #4a4a4a">{{ item.articleIntro }}</span>
            <div class="readmore" @click="toDetail(item.articleShortName)">
              {{ $t('con_read_more') }}
              <!--                READ MORE...-->
            </div>
          </div>
        </div>
      </div>
      <van-pagination
          v-model="newsPageNum"
          :total-items="newsTotal"
          @change="getLatestNewsList"
          :items-per-page="5"
          :prev-text="$t('con_PREV')"
          :next-text="$t('con_NEXT')"
          :show-page-size="5"
          force-ellipses
      />
    </div>

    <div class="last-news cat-news" style="background: #F9F9F9">
      <div class="hot"><span class="hot-name">{{ $t('con_bestnew') }}</span></div>
      <div class="last-news-content">
        <div v-for="item in recommendList" class="content-box" @click="toDetail(item.articleShortName)">
          <div class="bot-img">
            <img :src="item.articleImage || defaultImg" alt="">
          </div>
          <div style="padding: 0 20px 20px">
            <div class="last-news-content-box">
              <span class="title" style="margin-top: 10px; font-size: 15px">{{ item.articleTitle }}</span>
            </div>
            <div class="time">
<!--              <span class="country">{{ $t('con_time') }}</span>-->
<!--              <span>{{ // item.uploadTime }}</span>-->
              <span style="margin: 0 20px" class="see-number">{{ $t('con_see') }}</span>
              <span class="number">{{ item.articleReadNum }}</span>
            </div>
          </div>
        </div>
      </div>
      <van-pagination
          v-model="recommendPageNum"
          :total-items="recommendTotal"
          @change="getRecommendList"
          :items-per-page="6"
          :prev-text="$t('con_PREV')"
          :next-text="$t('con_NEXT')"
          :show-page-size="5"
          force-ellipses
      />
    </div>

    <div class="footer">
      <span>© 2023 - {{ dominItem.logoName || 'Logo' }}. All Rights Reserved. Website: {{ dominItem.logoName || 'Logo' }}</span>
    </div>

  </div>
</template>
<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName } from "@/api/index"
import {format} from 'date-fns'
import Clipboard from 'clipboard';
import {Toast} from 'vant';

export default {
  props: {
    dominItem: Object
  },
  data() {
    return {
      nodata: false,
      defaultImg: undefined,
      current: 1,
      clipboardText: window.location.href,
      currentPage: 1,
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7}],
      articleList: [],
      latestNewsList: [],
      recommendList: [],
      newsPageNum: 1,
      newsTotal: undefined,
      recommendPageNum: 1,
      recommendTotal: undefined,
      bestInfo: undefined,
      nowDate: undefined

    };
  },

  created() {
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getOneList()
    }
    this.nowDate = format(new Date(),  this.$t('con_format'))
    this.defaultImg = JSON.parse(localStorage.getItem('dominItem')).defaultImg

  },

  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getOneList()
    },
    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        this.bestInfo = res.data
        this.bestInfo.uploadTime = format(new Date(res.data.uploadTime), this.$t('con_format'))
      })
    },

    // 获取文章列表
    getArticleList() {
      this.nodata = true
      getContentList({articleCategoryId: this.current,articleNationId: this.dominItem.nationId}).then(res => {
        this.articleList = res.rows
        this.articleList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 5, articleNationId: this.dominItem.nationId}).then(res => {
        this.latestNewsList = res.rows
        this.newsTotal = res.total
        this.latestNewsList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        this.recommendList = res.rows
        this.recommendTotal = res.total
        this.recommendList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  },
};
</script>
<style lang="scss" scoped>
@import "kr";
</style>
